// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDoO__ja2ki9VbtXr-u9XnRsfprMdBHbpY",
  authDomain: "formulario-restaurante-9120d.firebaseapp.com",
  projectId: "formulario-restaurante-9120d",
  storageBucket: "formulario-restaurante-9120d.firebasestorage.app",
  messagingSenderId: "745547214229",
  appId: "1:745547214229:web:3157cad927575ccc7eda9c",
  measurementId: "G-XYJ5VC4EHP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
export { db };